import { createFileRoute } from '@tanstack/react-router';
import { RedditMarketingPage } from '../../../pages/tools/research-tools/RedditMarketingPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/reddit-marketing')({
  head: () => toolHead('reddit-marketing'),
  component: RedditMarketingPage,
});
